<div class="modal-container-custom">
  <div class="modal-content-custom uploadLetterStyle_1">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="additional-data-modal-close"
        (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">{{title}}</h4>
    </div>
    <div class="modal-body">
      <div>
        <small>Select Date, Upload optional attachment and Proceed to generate the document.</small>
      </div>
      <div class="dark-section">
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="compt-input mt-2 mb-4">
              <label>Date</label>
              <div class="r-value-box">
                <input [attr.value]="documentDate" id="document-date" class="form-control block-box text-left pt-5"
                  [outsideDays]="'collapsed'" placeholder="Document Date" name="document-date" [(ngModel)]="documentDate"
                  ngbDatepicker [minDate]="looDateObj" [maxDate]="issueValueDateObj"
                  [markDisabled]="isWeekendAndHolidayDisabled" #documentDatePicker="ngbDatepicker"
                  #documentDateModel="ngModel" (click)="documentDatePicker.toggle()" [readonly]="true" required>
                <div class="input-group-append icons-calender">
                  <button class="btn" (click)="documentDatePicker.toggle()" type="button" id="document-date-btn">
                    <i class="far-i fa fa-calendar"></i>
                  </button>
                </div>
              </div>
              <div class="error-text" *ngIf="documentDateModel.errors">
                <small *ngIf="documentDateModel.errors.ngbDate">
                  <ng-container *ngIf="documentDateModel.errors.ngbDate.requiredBefore">
                    Date should be more than or equal to Letter Of Offer date : {{looDateFormatted}}.
                  </ng-container>
                  <ng-container *ngIf="documentDateModel.errors.ngbDate.requiredAfter">
                    Date should be less than or equal to Issue Value Date : {{issueValueDateFormatted}}.
                  </ng-container>
                </small>
                <small *ngIf="documentDateModel.errors.required">
                  Date is required for document generation.
                </small>
              </div>
            </div>
          </div>
        </div>
        <br>
        <div class="row mb-4">
          <div class="col-md-7 align-center">
            <app-upload-button #uploadComp [uploadType]="'KEY'" [componentId]="'additional_attachment_' + this.docKey"
              [fileTypes]="fileTypes" displayText="Additional attachment" (fileAsDataURL)="setAdditionalDocs($event)">
            </app-upload-button>
          </div>
          <div class="col-md-5">
            <small class="border-bottom" *ngIf="!existingDoc">{{uploadComp.fileName || "None attached"}}</small>
            <a class="border-bottom cursor-pointer" *ngIf="existingDoc" (click)="showDoc(existingDoc.file_url)">{{
              existingDoc.file_name }}</a>
          </div>
        </div>
        <small class="ml-2">(Optional)</small>
        <div *ngIf="additionalAttachment" class="row mt-3">
          <div class="col-md-12">
            <div class="compt-input">
              <label>Attachment Description</label>
              <div class="r-value-box">
                <input [attr.id]="'attachment_description_' + this.docKey" type="text"
                  [(ngModel)]="attachmentDescription" class="form-control block-box">
              </div>
              <small class="text-left">
                Attachment Description will be shown on the {{title}} document.
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer modal-footer-custom">
      <button type="button" class="col-md-4 btn btn-outline-normal btn-style-right-1 text-left"
        id="additional-data-modal-cancel" (click)="activeModal.close()">Cancel</button>
      <button type="submit"
        class="col-md-4 btn btn-md btn-style-right-1 btn-success text-left for-icon-right for-right-arrow"
        id="additional-data-modal-generate" (click)="setAdditionalData(documentDateModel.errors)">Generate</button>
    </div>
  </div>
</div>